/** LinkedIn signal post preview strings (Feed + Profile Tracker timeline). */
export const enSignalTimeline = {
	linkedinPost: "LinkedIn post",
	linkedinLikes: "{{count}} likes",
	linkedinComments: "{{count}} comments",
	linkedinShares: "{{count}} shares",
	viewOnLinkedin: "View on LinkedIn",
	postImage: "Post image",
	playVideo: "Play video",
	viewDocument: "View document",
	/** List-appearance timeline entries (PREC-2496). */
	appearedOnList: "Appeared on this lead list",
	colleagueAppearedOnList: "{{name}} appeared on this lead list",
};
